import { useState } from "react";
import { Link } from "react-router-dom";
import "./onboardingBanner.css";
import { CheckCircle, RadioButtonUnchecked, Close } from "@mui/icons-material";
import { useGetAllProductQuery, useGetAllCategoriesQuery } from "../../../services/productApi";
import { useGetAllBannersQuery } from "../../../services/bannerApi";
import { useGetAllCouponsQuery } from "../../../services/couponApi";

const DISMISS_KEY = "bakenow_admin_onboarding_dismissed";

const countOf = (data) =>
  data?.count ?? (Array.isArray(data?.results) ? data.results.length : Array.isArray(data) ? data.length : 0);

export default function OnboardingBanner() {
  const [dismissed, setDismissed] = useState(
    typeof window !== "undefined" && window.localStorage.getItem(DISMISS_KEY) === "true"
  );

  const { data: products } = useGetAllProductQuery();
  const { data: categories } = useGetAllCategoriesQuery();
  const { data: banners } = useGetAllBannersQuery();
  const { data: coupons } = useGetAllCouponsQuery();

  const steps = [
    { label: "Add your first category", done: countOf(categories) > 0, to: "/admin/categories" },
    { label: "Add your first product", done: countOf(products) > 0, to: "/admin/products" },
    { label: "Create a homepage banner", done: countOf(banners) > 0, to: "/admin/banners" },
    { label: "Set up a coupon or discount", done: countOf(coupons) > 0, to: "/admin/coupons" },
  ];

  const completedCount = steps.filter((s) => s.done).length;

  if (dismissed || completedCount === steps.length) return null;

  const handleDismiss = () => {
    window.localStorage.setItem(DISMISS_KEY, "true");
    setDismissed(true);
  };

  return (
    <div className="onboarding">
      <div className="onboarding__top">
        <div>
          <h2>Getting started with BakeNow</h2>
          <p>{completedCount} of {steps.length} steps complete</p>
        </div>
        <button type="button" className="onboarding__close" onClick={handleDismiss} aria-label="Dismiss">
          <Close />
        </button>
      </div>
      <div className="onboarding__progress">
        <div className="onboarding__progress-bar" style={{ width: `${(completedCount / steps.length) * 100}%` }} />
      </div>
      <div className="onboarding__steps">
        {steps.map((step) => (
          <Link to={step.to} key={step.label} className={`onboarding__step ${step.done ? "onboarding__step--done" : ""}`}>
            {step.done ? <CheckCircle /> : <RadioButtonUnchecked />}
            <span>{step.label}</span>
          </Link>
        ))}
      </div>
    </div>
  );
}
